module.exports = __webpack_public_path__ + "static/media/house-bedroom.8c31efc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/house/house-bedroom.png
// module id = 194
// module chunks = 0